import { BaseDiv, BaseDivProps } from './BaseDiv';

export const Column = (props: BaseDivProps) => {
  return (
    <BaseDiv {...props} direction="column">
      {props.children}
    </BaseDiv>
  );
};
